import React, {useState, useEffect} from 'react';

const CategorySection = (props) => {
  
    var categories = [];
    var categoryArray = {};

    var sectionData = props.sectionData;
    /********categories section*******/
   if(sectionData){

    console.log("category run");
    sectionData.forEach(element => {
      categories.push(...element.categories);
     });

     const counts = {};
     categories.forEach(function (x) { categoryArray[x] = (categoryArray[x] || 0) + 1; });
     console.log(categoryArray);


     /******make unique*****/
    //  categoryArray = [...new Set(categories)];
    //  console.log(categoryArray);
   }


    /***On chnage each category term***/
    const onChnageFilterCheckbox = () => { 
     // var myArray = new Array();

      var checkboxes = document.getElementsByName('categoryterm[]');
      var vals = "";
      for (var i=0, n=checkboxes.length;i<n;i++) 
      {
          if (checkboxes[i].checked) 
          {
              vals += ","+checkboxes[i].value;
          }
      }
      //removing comma from first
      var dataRemoveComma = vals.substring(1);
      const myArray = dataRemoveComma.split(",");

      /*****passing selected category list*****/
      props.getQuestionsByCategories(myArray);

  }; 

  /****Category sidebar section*****/
  const CategoriesSection = (categoriesdata) => {
    var catData = categoriesdata.datacategory;

    var cnt = 0;
    return Object.keys(catData).map(key => {
        cnt++;
        return <li key={cnt}><input type="checkbox" name="categoryterm[]" id={"checkbox"+cnt} value={key} onChange={onChnageFilterCheckbox} /><label htmlFor={"checkbox"+cnt}>{key}{"("+catData[key]+")"}</label></li>
        }
    )
  }

  return (
        <>
            {categoryArray && <ul className="category-ul"><CategoriesSection datacategory={categoryArray}/></ul>}
        </>
  )
}

export default CategorySection;